var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:Object.assign({}, {outline: _vm.outline, disabled: _vm.disabled, rect: _vm.rect, small: _vm.small, auto: _vm.auto}, ( _obj = {}, _obj[_vm.color] = true, _obj )),on:{"click":_vm.click}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }